export const getWindowLocation = (): {
  href: string;
  origin: string;
  pathname: string;
  search: string;
} => {
  if (typeof window === 'undefined' || window === null) {
    return {
      href: '',
      origin: '',
      pathname: '',
      search: '',
    };
  }
  return window.location;
};

export const getWindowLocalEnv = (): Window['localEnv'] => {
  if (typeof window === 'undefined' || window === null) {
    return {
      advertiserId: '',
      localAuth: undefined,
    };
  }

  return window.localEnv;
};
